import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="App">
            <header className="hero-section" style={{ minHeight: 'auto', padding: '60px 20px', paddingBottom: '20px' }}>
                <div className="hero-content">
                    <h1 className="app-title" style={{ fontSize: '3.5rem', marginBottom: '10px' }}>Privacy Policy</h1>
                </div>
            </header>
            
            <section className="about-content" style={{
                maxWidth: '900px',
                margin: '0 auto',
                padding: '0 20px 80px',
                textAlign: 'left',
                direction: 'ltr'
            }}>
                <div style={{
                    fontSize: '1.1rem',
                    lineHeight: '1.8',
                    color: 'rgba(255, 255, 255, 0.9)'
                }}>
                    <p style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                        Privacy Policy for רב אלוף (Rav Aluf)
                    </p>
                    <p style={{ marginBottom: '30px', color: 'rgba(255, 255, 255, 0.7)' }}>
                        Last updated: January 2026
                    </p>
                    <p style={{ marginBottom: '30px' }}>
                        Liad Zigdon built the רב אלוף app as a Free app. This SERVICE is provided by Liad Zigdon at no cost and is intended for use as is.
                    </p>
                    <p style={{ marginBottom: '30px' }}>
                        This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service.
                    </p>

                    <h2 style={{ 
                        fontSize: '1.8rem', 
                        marginTop: '40px', 
                        marginBottom: '20px',
                        color: '#ffffff',
                        fontWeight: '600'
                    }}>
                        1. Information Collection and Use
                    </h2>
                    <p style={{ marginBottom: '20px' }}>
                        For a better experience, while using our Service, I may require you to provide us with certain personally identifiable information. The information that I request will be retained on your device and is not collected by me in any way.
                    </p>
                    <ul style={{ marginBottom: '30px', paddingLeft: '20px' }}>
                        <li style={{ marginBottom: '10px' }}>Google Play Services</li>
                        <li style={{ marginBottom: '10px' }}>AdMob</li>
                        <li style={{ marginBottom: '10px' }}>Firebase Analytics</li>
                    </ul>

                    <h2 style={{ 
                        fontSize: '1.8rem', 
                        marginTop: '40px', 
                        marginBottom: '20px',
                        color: '#ffffff',
                        fontWeight: '600'
                    }}>
                        2. Log Data
                    </h2>
                    <p style={{ marginBottom: '30px' }}>
                        I want to inform you that whenever you use my Service, in a case of an error in the app I collect data and information (through third-party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol ("IP") address, device name, operating system version, the configuration of the app when utilizing my Service, the time and date of your use of the Service, and other statistics.
                    </p>

                    <h2 style={{ 
                        fontSize: '1.8rem', 
                        marginTop: '40px', 
                        marginBottom: '20px',
                        color: '#ffffff',
                        fontWeight: '600'
                    }}>
                        3. Cookies
                    </h2>
                    <p style={{ marginBottom: '30px' }}>
                        This Service does not use these "cookies" explicitly. However, the app may use third-party code and libraries that use "cookies" to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device.
                    </p>

                    <h2 style={{ 
                        fontSize: '1.8rem', 
                        marginTop: '40px', 
                        marginBottom: '20px',
                        color: '#ffffff',
                        fontWeight: '600'
                    }}>
                        4. Children's Privacy
                    </h2>
                    <p style={{ marginBottom: '30px' }}>
                        These Services do not address anyone under the age of 13. I do not knowingly collect personally identifiable information from children under 13. In the case I discover that a child under 13 has provided me with personal information, I immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact me so that I will be able to do necessary actions.
                    </p>

                    <h2 style={{ 
                        fontSize: '1.8rem', 
                        marginTop: '40px', 
                        marginBottom: '20px',
                        color: '#ffffff',
                        fontWeight: '600'
                    }}>
                        5. Changes to This Privacy Policy
                    </h2>
                    <p style={{ marginBottom: '30px' }}>
                        I may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. I will notify you of any changes by posting the new Privacy Policy on this page.
                    </p>

                    <h2 style={{ 
                        fontSize: '1.8rem', 
                        marginTop: '40px', 
                        marginBottom: '20px',
                        color: '#ffffff',
                        fontWeight: '600'
                    }}>
                        6. Contact Us
                    </h2>
                    <p style={{ marginBottom: '40px' }}>
                        If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me at <a href="mailto:lilizigi@gmail.com" style={{ color: '#ffffff', textDecoration: 'underline' }}>lilizigi@gmail.com</a>.
                    </p>
                </div>
                
                <div style={{ marginTop: '60px', textAlign: 'center' }}>
                    <button 
                        onClick={() => navigate('/')} 
                        className="footer-link"
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '1rem',
                            cursor: 'pointer',
                            padding: '10px'
                        }}
                    >
                        Back to Home
                    </button>
                </div>
            </section>
        </div>
    );
};

export default PrivacyPolicy;

